import { useLang } from '../../i18n/LanguageContext'

export default function OnboardingHome() {
  const { t } = useLang()

  return (
    <div className="wizard">
      <div className="wizard__card">
        <div className="wizard__body" style={{ textAlign: 'center' }}>
          <div style={{
            width: 64, height: 64, margin: '0 auto 1.5rem',
            background: 'var(--color-primary-50)', borderRadius: '50%',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '1.75rem'
          }}>
            🏢
          </div>

          <h1 className="wizard__title">{t('onboarding.homeTitle')}</h1>
          <p className="wizard__subtitle">
            {t('onboarding.homeSubtitle')}
          </p>

          <div className="alert alert--warning" style={{ textAlign: 'left' }}>
            <strong>{t('onboarding.homeGotLink')}</strong><br />
            {t('onboarding.homeGotLinkText')}
          </div>

          <div style={{ marginTop: '2rem' }}>
            <a
              href="/"
              className="btn btn--secondary"
              style={{ textDecoration: 'none' }}
            >
              {t('onboarding.homeBack')}
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
